export const endpoint = {
  banners: '/website/banners',
  totalDeliveredOrders: '/website/totalDeliveredOrders',
  topRatedDishes: '/website/topRatedDishes',
  cms: '/website/cms',
  subscriptionPlans: '/website/subscriptionPlans',
  additionalCallsPlans: '/website/additionalCallsPlans',
  restaurantLogin: '/restaurant/login',
  restaurantSubscriptionCheckout: '/restaurant/createRestaurantSubscriptionCheckout',
  getCurrentRestaurantSubscription: '/restaurant/getCurrentRestaurantSubscription',
  additionalCallsCheckout: '/restaurant/createAdditionalCallsCheckout',
  faq: '/website/faq',
  faqRestaurant: '/website/faq?role=Restaurant',
  aboutUs: '/website/about-us',
  privacyPolicy: '/website/privacy-policy',
  termsAndConditions: '/website/terms-and-conditions',
};